const moduleIconMap = {
  content: 'page-content',
  indexing: 'seo',
  mobile: 'mobile',
  structured_data: 'structured_data',
  security: 'lock',
  performance: 'speed',
  accessibility: 'accessibility',
  technologies: 'technologies',
  branding: 'branding',
  domain: 'domain',
  backlinks: 'backlinks',
  traffic: 'visitors',
  sync_with_ga: 'google-analytics-nofill',
  local: 'local',
  social_profiles: 'social',
  facebook_sync: 'facebook-circular',
  serp: 'serp',
  sync_with_gsc: 'google-search-console-nocolor'
};

export default module => moduleIconMap[module];
